import { Logger, LoggerService } from '@Shared/logger';
import { EntitlementOptions } from './_models';
import { EntitlementService } from './services/entitlement.service';
import { Bus } from '@Modules/event_module';
import { APP_EVENTS } from '@Core';

export class EntitlementModuleClass {
  private Logger: Logger = LoggerService.createLogger('EntitlementModule');

  private options: EntitlementOptions;

  get Options(): EntitlementOptions {
    return this.options;
  }

  constructor() {
    this.Logger.trace('**** CTOR ****');
  }

  public async init(opts: EntitlementOptions): Promise<void> {
    this.Logger.trace('Options Initializing');
    try {
      this.options = opts;

      // Clear entitlements on logout via the event bus rather than auth_module
      // to avoid circular dependency
      Bus.on(APP_EVENTS.onLogout, () => {
        // Two independent stores, cleared side by side: ours (local + session server)
        // and the entitler's cache. Neither call nests inside the other, so logout
        // sends one DELETE per store.
        EntitlementService.Instance.clearEntitlementState();
        EntitlementService.Instance.clearEntitlerCache().then((cleared) => {
          this.Logger.trace(
            cleared ? 'User cache cleared.' : 'User cache deletion failed.',
          );
        });
      });

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export const EntitlementModule = new EntitlementModuleClass();
